// extracted by mini-css-extract-plugin
export default {"link":"Faq_link__cDTT7","content":"Faq_content__h-hgF","mediumBody":"Faq_mediumBody__iCUEY","smallBody":"Faq_smallBody__X7aYF"};